import { AxiosResponse } from 'axios';
import { BASE_URL } from '../../config/environmentConfig';
import { ON_BOARDING_ROUTES } from '../utils/constatns';
import { sendSentryMessage } from '../utils/sentry-helper';
import * as Sentry from '@sentry/react';
import { POST, PUT } from '../store/store-helper';

export const editNewApplicant = async (params, id, formik): Promise<AxiosResponse<any>> => {
	console.log('editNewApplicant', params, id);
	// const res = await axios.put(`${BASE_URL.MERCHANTS}/${ON_BOARDING_ROUTES.ON_BOARDING}`, params);
	// const data = await axios.put(`${BASE_URL.MERCHANTS}/${ON_BOARDING_ROUTES.ON_BOARDING}/admin/application/${id}`, params);
	return await PUT({ pathname: `${BASE_URL.MERCHANTS}/${ON_BOARDING_ROUTES.ON_BOARDING}/admin/application/${id}`, body: params, formik });
};

export const saveNewApplicant = async (params, formik): Promise<AxiosResponse<any>> => {
	// await axios.post(`${BASE_URL.MERCHANTS}/${ON_BOARDING_ROUTES.ON_BOARDING}`, params);
	// return await axios.post(`${BASE_URL.MERCHANTS}/${ON_BOARDING_ROUTES.ON_BOARDING}/admin/application`, params);
	return await POST({ pathname: `${BASE_URL.MERCHANTS}/${ON_BOARDING_ROUTES.ON_BOARDING}/admin/application`, body: params, formik });
};

export const approveApplication = async ({ applicationId, onSuccess, onError }): Promise<void> => {
	try {
		await POST({ pathname: `${BASE_URL.MERCHANTS}/${ON_BOARDING_ROUTES.ON_BOARDING}/admin/application/${applicationId}/convert` });

		onSuccess();
	} catch (e) {
		Sentry.setTag('id', applicationId);
		sendSentryMessage({ name: `POST OnBoarding convert error`, context: e });
		console.log('approve app error', e.response);
		onError();
	}
};

export const cancelApplication = async ({ applicationId, handleSuccess, onError }): Promise<void> => {
	try {
		// await axios.post(`${BASE_URL.MERCHANTS}/${ON_BOARDING_ROUTES.ON_BOARDING}/admin/application/${applicationId}/cancel`);
		await POST({ pathname: `${BASE_URL.MERCHANTS}/${ON_BOARDING_ROUTES.ON_BOARDING}/admin/application/${applicationId}/cancel` });
		handleSuccess();
	} catch (e) {
		Sentry.setTag('applicationId', applicationId);
		sendSentryMessage({ name: `POST OnBoarding cancel error`, context: e });
		console.log('cancelApplication error', e);
		onError();
	}
};

export const declineApplication = async ({ applicationId, handleSuccess, onError }): Promise<void> => {
	try {
		// await axios.post(`${BASE_URL.MERCHANTS}/${ON_BOARDING_ROUTES.ON_BOARDING}/admin/application/${applicationId}/decline`);
		await POST({ pathname: `${BASE_URL.MERCHANTS}/${ON_BOARDING_ROUTES.ON_BOARDING}/admin/application/${applicationId}/decline` });
		handleSuccess();
	} catch (e) {
		Sentry.setTag('id', applicationId);
		sendSentryMessage({ name: `POST OnBoarding decline error`, context: e });
		onError();
	}
};

export const reopenApplication = async ({ applicationId, handleSuccess, onError }): Promise<void> => {
	try {
		// await axios.post(`${BASE_URL.MERCHANTS}/${ON_BOARDING_ROUTES.ON_BOARDING}/admin/application/${applicationId}/reopen`);
		await POST({ pathname: `${BASE_URL.MERCHANTS}/${ON_BOARDING_ROUTES.ON_BOARDING}/admin/application/${applicationId}/reopen` });
		handleSuccess();
	} catch (e) {
		Sentry.setTag('id', applicationId);
		sendSentryMessage({ name: `POST OnBoarding decline error`, context: e });
		onError();
	}
};
